/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import PropTypes from 'prop-types';

import { Cross } from 'icons';

import * as Styled from './Chip.styled';

export default function Chip({ children, onDelete, buttonTitle = `Remove ${children}`, ...props }) {
  return (
    <Styled.Wrapper data-test="chip" {...props}>
      {children}
      {onDelete && (
        <Styled.Button onClick={onDelete} title={buttonTitle} type="button" aria-label="Delete">
          <Cross width="14" height="14" />
        </Styled.Button>
      )}
    </Styled.Wrapper>
  );
}

Chip.propTypes = {
  children: PropTypes.node.isRequired,
  onDelete: PropTypes.func,
  buttonTitle: PropTypes.string
};
